"use client";

import { useEffect } from "react";

/**
 * Registers the service worker so browsers can install Virtuous as a PWA.
 * Forces update checks so old SW caches (which broke React hydration) get replaced.
 */
export function PwaRegister() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;

    const onLoad = () => {
      navigator.serviceWorker
        .register("/sw.js")
        .then((reg) => {
          // Pick up new sw.js (e.g. network-first for /_next)
          void reg.update();
          // If a new worker is waiting, activate it
          if (reg.waiting) {
            reg.waiting.postMessage?.({ type: "SKIP_WAITING" });
          }
        })
        .catch(() => {
          /* non-fatal in dev / restricted contexts */
        });
    };

    if (document.readyState === "complete") onLoad();
    else window.addEventListener("load", onLoad);
    return () => window.removeEventListener("load", onLoad);
  }, []);

  return null;
}
